// import React, { useRef, useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const Sponsors = () => {
//   const scrollRef = useRef(null);
//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(false);

//   const sponsors = [
//     {
//       name: "Prime Bank",
//       logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158356/WhatsApp_Image_2025-08-14_at_1.52.16_PM_vcnxpd.jpg",
//     },
//     {
//       name: "Vorosha Group",
//       logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/varosha_hfzsug.jpg",
//     },
//     {
//       name: "RFL Group",
//       logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/RFL_Group_vvw55h.jpg",
//     },
//     {
//       name: "Steadfast Courier Limited",
//       logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/WhatsApp_Image_2025-08-14_at_1.51.39_PM_xknlye.jpg",
//     },
//   ];

//   const checkScrollPosition = () => {
//     if (scrollRef.current) {
//       const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
//       setShowLeftArrow(scrollLeft > 0);
//       setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
//     }
//   };

//   const scroll = (direction) => {
//     if (scrollRef.current) {
//       const scrollAmount = 300;
//       scrollRef.current.scrollBy({
//         left: direction === "left" ? -scrollAmount : scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };

//   useEffect(() => {
//     const currentRef = scrollRef.current;
//     currentRef?.addEventListener("scroll", checkScrollPosition);
//     window.addEventListener("resize", checkScrollPosition);
//     checkScrollPosition(); // Initial check

//     return () => {
//       currentRef?.removeEventListener("scroll", checkScrollPosition);
//       window.removeEventListener("resize", checkScrollPosition);
//     };
//   }, []);

//   return (
//     <section className="py-16 px-4 md:px-20 bg-gray-50 relative">
//       <div className="max-w-7xl mx-auto relative">
//         <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//           Our Valued Sponsors
//         </h2>

//         <div className="relative">
//           {/* Left Arrow - only shows when needed */}
//           {showLeftArrow && (
//             <button
//               onClick={() => scroll("left")}
//               className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               aria-label="Scroll left"
//             >
//               <ChevronLeft size={24} />
//             </button>
//           )}

//           {/* Scrollable Sponsor Cards */}
//           <div
//             ref={scrollRef}
//             className="flex lg:items-center lg:justify-center overflow-x-auto gap-8 pb-4 scrollbar-hide scroll-smooth px-2"
//             style={{ scrollBehavior: "smooth" }}
//           >
//             {sponsors.map((sponsor, index) => (
//               <div
//                 key={index}
//                 className="flex-shrink-0 w-48 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
//               >
//                 <div className="h-32 flex items-center justify-center p-4">
//                   <img
//                     src={sponsor.logo}
//                     alt={sponsor.name}
//                     className="max-h-full max-w-full object-contain"
//                   />
//                 </div>
//                 <div className="p-4 border-t border-gray-100">
//                   <p className="text-center font-medium text-sm">
//                     {sponsor.name}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Right Arrow - only shows when needed */}
//           {showRightArrow && (
//             <button
//               onClick={() => scroll("right")}
//               className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               aria-label="Scroll right"
//             >
//               <ChevronRight size={24} />
//             </button>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Sponsors;

import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Trophy, Sparkles } from "lucide-react";

const Sponsors = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const videoRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const sponsors = [
    {
      name: "Prime Bank",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158356/WhatsApp_Image_2025-08-14_at_1.52.16_PM_vcnxpd.jpg",
      category: "Platinum Sponsor",
      description: "Leading financial partner supporting excellence",
    },
    {
      name: "Vorosha Group",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/varosha_hfzsug.jpg",
      category: "Gold Sponsor",
      description: "Dedicated to community development and sports",
    },
    {
      name: "RFL Group",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/RFL_Group_vvw55h.jpg",
      category: "Silver Sponsor",
      description: "Innovation and quality in partnership",
    },
    {
      name: "Steadfast Courier Limited",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/WhatsApp_Image_2025-08-14_at_1.51.39_PM_xknlye.jpg",
      category: "Bronze Sponsor",
      description: "Reliable logistics, strong partnership",
    },
  ];

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);

      // Calculate active index based on scroll position
      const itemWidth = scrollRef.current.children[0]?.offsetWidth || 0;
      const scrollIndex = Math.round(scrollLeft / itemWidth);
      setActiveIndex(scrollIndex);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const scrollToIndex = (index) => {
    if (scrollRef.current) {
      const itemWidth = scrollRef.current.children[0]?.offsetWidth || 0;
      const scrollPosition = itemWidth * index;
      scrollRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
    checkScrollPosition(); // Initial check

    return () => {
      currentRef?.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, []);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-gradient-to-br from-emerald-50 via-white to-lime-50 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 bg-emerald-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-lime-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute top-1/4 left-1/4 w-24 h-24 bg-gradient-to-br from-emerald-200 to-transparent rounded-full opacity-10"></div>
        <div className="absolute bottom-1/4 right-1/4 w-32 h-32 bg-gradient-to-br from-lime-200 to-transparent rounded-full opacity-10"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-full blur-lg opacity-30"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-amber-50 to-yellow-50 border-2 border-amber-100 flex items-center justify-center shadow-lg">
                <Trophy className="w-10 h-10 text-amber-600" />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mb-4">
            <Sparkles className="w-5 h-5 text-amber-500" />
            <p className="text-sm font-semibold tracking-widest text-amber-600 uppercase">
              Strategic Partnerships
            </p>
            <Sparkles className="w-5 h-5 text-amber-500" />
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
            Our Valued{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Sponsors</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-amber-300 to-yellow-300 opacity-40 -rotate-1"></span> */}
            </span>
          </h2>

          <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
            Proudly partnered with industry leaders who share our vision for
            excellence and community development
          </p>
        </div>

        {/* Sponsor Slider Container */}
        <div ref={videoRef} className="relative">
          {/* Left Arrow */}
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 md:-translate-x-8 bg-white/90 backdrop-blur-sm shadow-2xl rounded-full p-3 z-20 hover:bg-white transition-all duration-300 group hover:scale-110 border border-gray-200"
              aria-label="Scroll left"
            >
              <ChevronLeft className="w-6 h-6 text-gray-700 group-hover:text-amber-600 transition-colors" />
            </button>
          )}

          {/* Scrollable Sponsor Cards */}
          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-8 pb-8 px-4 scrollbar-hide scroll-smooth"
            style={{ scrollBehavior: "smooth" }}
          >
            {sponsors.map((sponsor, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-72 md:w-80 lg:w-96 group"
                onClick={() => scrollToIndex(index)}
              >
                <div
                  className={`
                  bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-2xl 
                  transition-all duration-500 transform hover:-translate-y-2 
                  border-2 ${
                    index === activeIndex
                      ? "border-amber-300"
                      : "border-gray-100"
                  }
                  overflow-hidden cursor-pointer
                `}
                >
                  {/* Category Badge */}
                  {/* <div className="px-6 pt-6">
                    <div
                      className={`
                      inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold 
                      ${
                        sponsor.category === "Platinum Sponsor"
                          ? "bg-gradient-to-r from-gray-800 to-gray-600 text-white"
                          : sponsor.category === "Gold Sponsor"
                          ? "bg-gradient-to-r from-amber-500 to-yellow-500 text-white"
                          : sponsor.category === "Silver Sponsor"
                          ? "bg-gradient-to-r from-gray-400 to-gray-300 text-gray-800"
                          : "bg-gradient-to-r from-amber-700 to-yellow-700 text-white"
                      }
                    `}
                    >
                      <Award className="w-3 h-3" />
                      {sponsor.category}
                    </div>
                  </div> */}

                  {/* Logo Container */}
                  <div className="p-8">
                    <div className="h-48 flex items-center justify-center p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 group-hover:border-amber-100 transition-colors duration-300">
                      <div className="relative w-full h-full flex items-center justify-center">
                        <div className="absolute inset-0 bg-gradient-to-br from-transparent to-gray-50/50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <img
                          src={sponsor.logo}
                          alt={sponsor.name}
                          className="max-h-full max-w-full object-contain filter group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Sponsor Info */}
                  <div className="px-6 pb-8 text-center">
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                      {sponsor.name}
                    </h3>
                    {/* <p className="text-gray-600 text-sm md:text-base mb-4">
                      {sponsor.description}
                    </p> */}

                    {/* Progress Indicator */}
                    <div className="flex items-center justify-center gap-1">
                      {sponsors.map((_, idx) => (
                        <button
                          key={idx}
                          onClick={(e) => {
                            e.stopPropagation();
                            scrollToIndex(idx);
                          }}
                          className={`w-2 h-2 rounded-full transition-all duration-300 ${
                            idx === activeIndex
                              ? "w-8 bg-gradient-to-r from-amber-500 to-yellow-500"
                              : "bg-gray-300 hover:bg-amber-400"
                          }`}
                          aria-label={`Go to sponsor ${idx + 1}`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          {showRightArrow && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 md:translate-x-8 bg-white/90 backdrop-blur-sm shadow-2xl rounded-full p-3 z-20 hover:bg-white transition-all duration-300 group hover:scale-110 border border-gray-200"
              aria-label="Scroll right"
            >
              <ChevronRight className="w-6 h-6 text-gray-700 group-hover:text-amber-600 transition-colors" />
            </button>
          )}
        </div>

        {/* Scroll Indicator */}
        {/* <div className="flex items-center justify-center gap-3 mt-8">
          <span className="text-sm text-gray-500">
            Scroll or swipe to explore
          </span>
          <div className="animate-bounce">
            <ChevronRight className="w-4 h-4 text-amber-500" />
          </div>
        </div> */}

        {/* Partnership Message */}
        <div className="mt-16 md:mt-20 text-center">
          <div className="bg-gradient-to-r from-emerald-50 to-lime-50 rounded-2xl p-8 md:p-12 border border-emerald-100 shadow-sm">
            <div className="inline-flex items-center justify-center mb-6">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-100 to-lime-100 border-2 border-emerald-200 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Interested in Partnership?
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto mb-6">
              Join our esteemed list of sponsors and showcase your commitment to
              excellence in sports and community development.
            </p>
            <button className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl">
              <Sparkles className="w-4 h-4" />
              Become a Sponsor
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
